<template>
    <Breadcrumbs main="Buttons" title="Default Style" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <defultsButtons />
                <defultsButtons2 />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const defultsButtons = defineAsyncComponent(() => import("@/components/theme/buttons/default/defultsButtons.vue"))
const defultsButtons2 = defineAsyncComponent(() => import("@/components/theme/buttons/default/defultsButtons2.vue"))

</script>